export default __webpack_public_path__ + "static/media/next.c3bcfa02.svg";